import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
export function PricingSection() {
  const checkoutUrl = 'https://checkout.guiadigital360.online/cart/43946518052933:1';
  return <section id="compra" className="py-12 md:py-24 px-4 bg-brand-light scroll-mt-10" data-id="element-212">
      <div className="max-w-6xl mx-auto" data-id="element-213">
        <div className="text-center mb-10 md:mb-16" data-id="element-214">
          <h2 className="text-5xl font-black text-brand-dark mb-4" data-id="element-215">
            Elegí tu MegaPack Física en Acción:
          </h2>
          <p className="text-2xl font-bold text-brand-blue" data-id="element-216">
            Precios de Lanzamiento
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6 md:gap-8 items-center mb-10 md:mb-16" data-id="element-217">
          {/* Card 1: Pack Completo */}
          <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-200 flex flex-col h-full relative" data-id="element-218">
            <div className="text-5xl mb-4" data-id="element-219">⚡</div>
            <h3 className="text-2xl font-black text-brand-dark mb-2" data-id="element-220">
              PACK COMPLETO — 7 TOMOS
            </h3>
            <p className="text-xl font-bold text-gray-700 mb-2" data-id="element-221">
              El más completo
            </p>
            <p className="text-gray-600 mb-2" data-id="element-222">
              Los 7 Tomos de Física en Acción (1° a 6° año + Feria de Ciencias)
            </p>
            <p className="text-gray-600 mb-2" data-id="element-223">+ Los 3 Bonos Estratégicos</p>
            <p className="text-gray-600 mb-8" data-id="element-224">
              + Acceso a actualizaciones de por vida
            </p>

            <div className="mt-auto" data-id="element-225">
              <div className="text-gray-400 text-xl line-through font-bold mb-1" data-id="element-226">
                $39.900
              </div>
              <div className="text-4xl font-black text-brand-orange mb-8" data-id="element-227">
                $19.990 ARS
              </div>
              <CTAButton text="→ QUIERO EL PACK COMPLETO" href={checkoutUrl} isLink={true} className="text-lg py-3" data-id="element-228" />
            </div>
          </div>

          {/* Card 2: VIP (Highlighted) */}
          <div className="bg-white rounded-3xl p-8 shadow-2xl border-4 border-brand-orange relative transform lg:scale-105 z-10 flex flex-col h-full" data-id="element-229">
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-brand-orange text-white font-black px-6 py-2 rounded-full text-sm tracking-widest shadow-md whitespace-nowrap" data-id="element-230">
              ⭐ MÁS ELEGIDO
            </div>

            <div className="text-5xl mb-4 text-center mt-4" data-id="element-231">🏆</div>
            <h3 className="text-3xl font-black text-brand-dark mb-2 text-center" data-id="element-232">
              COMBO SISTEMA TOTAL VIP
            </h3>

            <div className="bg-green-100 text-green-800 font-bold text-center py-2 rounded-lg mb-4" data-id="element-233">
              ¡No sufras más con los exámenes y la corrección!
            </div>

            <p className="text-xl font-bold text-gray-800 text-center mb-2" data-id="element-234">
              Contiene todo el Pack Completo + la Bóveda de Evaluación 360
            </p>
            <ul className="text-gray-600 text-sm mb-8 space-y-2 text-left mt-4" data-id="element-235">
              <li data-id="element-236">
                ✅ 40 modelos de exámenes listos para imprimir (Temas A, B y C
                para que nadie se copie)
              </li>
              <li data-id="element-237">
                ✅ Rúbricas maestras para corregir Prácticos, Proyectos y Feria
                de Ciencias
              </li>
              <li data-id="element-238">
                ✅ Planillas RITE 2026 listas para dirección (completás y
                entregás)
              </li>
              <li data-id="element-239">
                ✅ Solucionarios compactos para corregir en la mitad del tiempo
              </li>
              <li data-id="element-240">✅ Grillas de seguimiento de trayectorias (por alumno)</li>
            </ul>

            <div className="mt-auto text-center" data-id="element-241">
              <div className="text-gray-500 text-sm font-bold mb-2" data-id="element-242">
                Ahorrás $15.000 si comprás todo junto
              </div>
              <div className="text-5xl font-black text-brand-orange mb-8" data-id="element-243">
                $24.990 ARS
              </div>
              <CTAButton text="→ SÍ, QUIERO EL SISTEMA TOTAL VIP" href="https://checkout.guiadigital360.online/cart/44779029332037:1" isLink={true} className="text-xl py-4" data-id="element-244" />
            </div>
          </div>

          {/* Card 3: Física + Química */}
          <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-200 flex flex-col h-full" data-id="element-245">
            <div className="text-5xl mb-4 text-center" data-id="element-246">🏆</div>
            <h3 className="text-2xl font-black text-brand-dark mb-2 text-center" data-id="element-247">
              PACK COMPLETO
              <br data-id="element-248" />
              FÍSICA + QUÍMICA
            </h3>

            <div className="bg-green-100 text-green-800 font-bold text-center py-2 rounded-lg mb-4" data-id="element-249">
              AHORRÁS $9.000 ARS
            </div>

            <p className="text-xl font-bold text-gray-700 mb-2 text-center" data-id="element-250">
              Te llevas el combo completo de las dos materias
            </p>
            <p className="text-gray-600 mb-8 text-center" data-id="element-251">
              Todo listo y armado
            </p>

            <div className="mt-auto text-center" data-id="element-252">
              <div className="text-gray-400 text-xl line-through font-bold mb-1" data-id="element-253">
                $39.980
              </div>
              <div className="text-4xl font-black text-brand-orange mb-8" data-id="element-254">
                $30.980 ARS
              </div>
              <CTAButton text="→ SÍ, QUIERO EL PACK COMPLETO" href="https://checkout.guiadigital360.online/cart/44770181808197:1" isLink={true} className="text-lg py-3" data-id="element-255" />
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12 text-sm md:text-base text-gray-600 font-bold bg-white py-6 px-4 rounded-2xl shadow-sm border border-gray-100" data-id="element-256">
          <span className="flex items-center gap-2" data-id="element-257">
            <LockIcon className="w-6 h-6 text-gray-500" data-id="element-258" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-259">
            <ZapIcon className="w-6 h-6 text-yellow-500" data-id="element-260" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-261">
            <ShieldCheckIcon className="w-6 h-6 text-brand-green" data-id="element-262" /> Garantía 7
            días
          </span>
          <span className="flex items-center gap-2" data-id="element-263">
            <CreditCardIcon className="w-6 h-6 text-blue-500" data-id="element-264" /> Mercado Pago ·
            Tarjeta · Transferencia
          </span>
        </div>
      </div>
    </section>;
}